import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#050505] pt-20 pb-10 relative overflow-hidden" data-id="element-24">
      <div className="absolute top-0 inset-x-0 h-px bg-white/10" data-id="element-25"></div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-26">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16" data-id="element-27">
          <div className="md:col-span-5 flex flex-col items-start" data-id="element-28">
            <img src="https://cdn.magicpatterns.com/uploads/9eqxLFx7HNRwaS7nTrWySg/Captura_de_pantalla_2026-04-28_a_las_19.45.31-removebg-preview.png" alt="Growthly Logo" className="h-9 object-contain mb-6 filter brightness-0 invert" data-id="element-29" />
            <p className="text-gray-400 text-base leading-relaxed max-w-sm mb-8" data-id="element-30">
              Transformando negocios tradicionales en máquinas digitales premium
              de captación de clientes. Elevamos tu marca al siguiente nivel.
            </p>
            <div className="flex gap-4" data-id="element-31">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-gray-400 hover:text-brand-emerald hover:border-brand-emerald/50 hover:bg-brand-emerald/10 transition-all duration-300" data-id="element-32">
                <span className="sr-only" data-id="element-33">Instagram</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-34">
                  <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" data-id="element-35" />
                </svg>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-gray-400 hover:text-brand-emerald hover:border-brand-emerald/50 hover:bg-brand-emerald/10 transition-all duration-300" data-id="element-36">
                <span className="sr-only" data-id="element-37">LinkedIn</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-38">
                  <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" data-id="element-39" />
                </svg>
              </a>
            </div>
          </div>

          <div className="md:col-span-3" data-id="element-40">
            <h4 className="text-white font-bold mb-6 text-lg" data-id="element-41">Navegación</h4>
            <ul className="space-y-4" data-id="element-42">
              <li data-id="element-43">
                <Link to="/" className="text-gray-400 hover:text-brand-emerald transition-colors" data-id="element-44">
                  Inicio
                </Link>
              </li>
              <li data-id="element-45">
                <Link to="/servicios" className="text-gray-400 hover:text-brand-emerald transition-colors" data-id="element-46">
                  Servicios
                </Link>
              </li>
              <li data-id="element-47">
                <Link to="/proceso" className="text-gray-400 hover:text-brand-emerald transition-colors" data-id="element-48">
                  Proceso
                </Link>
              </li>
              <li data-id="element-49">
                <Link to="/resultados" className="text-gray-400 hover:text-brand-emerald transition-colors" data-id="element-50">
                  Resultados
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/faq" className="text-gray-400 hover:text-brand-emerald transition-colors" data-id="element-52">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4" data-id="element-53">
            <h4 className="text-white font-medium mb-6 text-[15px]" data-id="element-54">
              ¿Listo para crecer?
            </h4>
            <div className="card-premium p-6" data-id="element-55">
              <p className="text-gray-400 text-[13px] leading-relaxed mb-6" data-id="element-56">
                Inicia tu transformación digital hoy. Da el primer paso hacia un
                ecosistema que trabaje para ti.
              </p>

              <Link to="/contacto" className="flex items-center justify-center w-full h-11 text-center bg-white/[0.03] hover:bg-white/[0.06] text-white border border-white/[0.08] rounded-xl font-medium text-[13px] transition-colors duration-300" data-id="element-57">
                Contactar ahora
              </Link>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-58">
          <p className="text-gray-500 text-sm font-medium" data-id="element-59">
            &copy; {currentYear} Growthly. Todos los derechos reservados.
          </p>
          <div className="flex gap-6" data-id="element-60">
            <Link to="/privacidad" className="text-sm text-gray-500 hover:text-white transition-colors" data-id="element-61">
              Privacidad
            </Link>
            <Link to="/terminos" className="text-sm text-gray-500 hover:text-white transition-colors" data-id="element-62">
              Términos
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}